import { useNavigate } from 'react-router-dom'
import { useCommonCodes } from '@/shared/lib/codes'
import { ICON_BY_CODE } from '@/public/features/home/constants/homeCards'

export function CategoryIconsRow() {
  const groups = useCommonCodes('category_group')
  const navigate = useNavigate()

  return (
    <section className="flex items-start justify-center gap-5 pt-8" aria-label="분야">
      {(groups.data ?? []).map((g) => (
        <button
          key={g.code}
          type="button"
          className="ui-pressable flex w-[100px] cursor-pointer flex-col items-center gap-3 border-0 bg-transparent p-0"
          onClick={() => navigate(`/problems?group=${encodeURIComponent(g.code)}`)}
        >
          <span className="flex h-[68px] w-[68px] shrink-0 items-center justify-center overflow-clip rounded-[18px] bg-[#f5f6ff] p-3">
            {ICON_BY_CODE[g.code] !== undefined && (
              <img
                src={ICON_BY_CODE[g.code]}
                alt=""
                aria-hidden="true"
                className="h-[38px] w-10 object-contain"
              />
            )}
          </span>
          <span className="text-center text-body-sm font-medium text-black-600">{g.label}</span>
        </button>
      ))}
    </section>
  )
}
